<template>
  <div class="xc-page xc-page-sandwich">
    <!-- 分栏布局 -->
    <div class="xc-page-main">
      <!-- 面包屑 -->
      <div class="xc-breadcrumb">
        <router-link :to="this.$config.adminPath + '/program'"
          >节目管理</router-link
        >
        <a>预览节目</a>
      </div>

      <div class="xc-row program-wrap">
        <div class="program-info xc-col">
          <div class="xc-card">
            <div class="xc-card-header">
              <div class="xc-card-title">节目基本信息</div>
            </div>
            <div class="xc-card-content">
              <p>节目名称：{{ programInfo.programName }}</p>
              <p>投放级别：{{ programInfo.putinLevelName }}</p>
              <!-- <p>终端类型：{{programInfo.deviceType}}</p> -->
              <p>终端分辨率：{{ programInfo.deviceResolution }}</p>
              <p>投放开始时间：{{ programInfo.putinStartTime }}</p>
              <p>投放结束时间：{{ programInfo.putinEndTime }}</p>
              <!-- <p>节目基本信息</p> -->
              <p>
                投放周期：
                <span
                  v-for="(item, index) in programInfo.putinLimit"
                  :key="index"
                >
                  <span v-if="item == 0">周一&nbsp;</span>
                  <span v-if="item == 1">周二&nbsp;</span>
                  <span v-if="item == 2">周三&nbsp;</span>
                  <span v-if="item == 3">周四&nbsp;</span>
                  <span v-if="item == 4">周五&nbsp;</span>
                  <span v-if="item == 5">周六&nbsp;</span>
                  <span v-if="item == 6">周日</span>
                </span>
              </p>
              <div class="line"></div>
              <p>创建人：{{ programInfo.addUserName }}</p>
              <p>创建时间：{{ programInfo.addTime }}</p>
              <p>最后操作时间：{{ programInfo.updateTime }}</p>
            </div>
          </div>
        </div>
        <div class="program-preview xc-col">
          <div class="xc-card">
            <div class="xc-card-header">
              <div class="xc-card-title">预览区（{{ resolution }}）</div>
            </div>
            <div class="xc-card-content">
              <div
                class="device"
                :class="{
                  'device-1920': deviceType == 0,
                  'device-1080': deviceType == 1,
                }"
              >
                <div class="device-content">
                  <template v-if="currentProgram">
                    <template v-if="currentProgram.fileType == 'image'">
                      <div class="module-preview-item">
                        <div class="cover">
                          <img :src="currentProgram.url" />
                        </div>
                      </div>
                    </template>
                    <template v-else-if="currentProgram.fileType == 'video'">
                      <div class="module-preview-item">
                        <div class="cover">
                          <img :src="currentProgram.fileImageUrl" />
                        </div>
                        <!-- <div class="video-play-icon"></div> -->
                        <video
                          :src="
                            currentProgram.url +
                            '?playIndex=' +
                            currentProgram.playIndex
                          "
                          preload
                          controls
                          autoplay
                        ></video>
                      </div>
                    </template>
                    <template v-else-if="currentProgram.fileType == 'web'">
                      <div class="module-preview-item">
                        <div class="iframe">
                          <iframe
                            :src="currentProgram.url"
                            frameborder="0"
                          ></iframe>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="currentProgram.fileType == 'audio'">
                      <div class="module-preview-item">
                        <div class="iframe">
                          <audio controls ref="audio" class="aud">
                            <source :src="currentProgram.url" />
                          </audio>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 已选定 -->
        <div
          class="program-data xc-col"
          v-if="programInfo.deviceList && programInfo.deviceList.length"
        >
          <div class="xc-card" style="overflow: inherit">
            <div class="xc-card-header">
              <div class="xc-card-title">投放点位</div>
            </div>
            <div class="xc-card-content select-point">
              <div class="info">
                投放信息：共{{ programInfo.deviceGroupCount }}分组，{{
                  programInfo.deviceCount
                }}终端
              </div>

              <table class="xc-table">
                <thead>
                  <th>终端组</th>
                  <!-- <th>设备IP</th> -->
                  <th>终端名</th>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in programInfo.deviceList"
                    :key="index"
                  >
                    <td>{{ item.deviceGroupName }}</td>
                    <!-- <td>{{item.ip}}</td> -->
                    <td>{{ item.deviceName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="program-data xc-col" v-else>
          <div class="xc-card" style="overflow: inherit">
            <div class="xc-card-header">
              <div class="xc-card-title">节目素材页</div>
            </div>
            <div class="xc-card-content">
              <div class="module-list">
                <template v-if="programJson && programJson.length">
                  <div v-for="(item, key) in programJson" :key="key">
                    <template v-if="item.fileType == 'image'">
                      <div class="module-item module-item-image">
                        <div class="cover">
                          <img :src="item.url" />
                        </div>
                        <div class="info">
                          <span class="module-name"
                            >节目名称：{{ item.fileName }}</span
                          >
                          <span class="module-duration"
                            >节目时长：{{ item.duration / 1000 }}s</span
                          >
                        </div>
                      </div>
                    </template>
                    <template v-else-if="item.fileType == 'video'">
                      <div class="module-item module-item-video">
                        <div class="cover">
                          <img :src="item.fileImageUrl" />
                        </div>
                        <div class="info">
                          <span class="module-name"
                            >节目名称：{{ item.fileName }}</span
                          >
                          <span class="module-duration"
                            >节目时长：{{ item.duration / 1000 }}s</span
                          >
                        </div>
                        <div class="video-play-icon"></div>
                      </div>
                    </template>
                    <template v-else-if="item.fileType == 'web'">
                      <div class="module-item module-item-web">
                        <!-- <div class="iframe">
                                                    <iframe
                                                        :src="item.url"
                                                        frameborder="0"
                                                    ></iframe>
                                                </div> -->
                        <div class="web-icon">
                          <img src="../assets/program/web-default.png" />
                        </div>
                        <div class="info">
                          <span class="module-name"
                            >节目名称：{{ item.fileName }}</span
                          >
                          <span class="module-duration"
                            >节目时长：{{ item.duration / 1000 }}s</span
                          >
                        </div>
                        <div class="btn-del" @click="deleteModule(key)"></div>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="module-item module-item-null">
                    <div class="icon">
                      <img src="../assets/icon-null.png" />
                    </div>
                    <div class="tips">
                      暂无素材内容，点击上方按钮添加素材内容
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="xc-page-footer">
      <div class="xc-btn-group">
        <!-- <router-link class="xc-btn xc-btn-default" :to="$config.adminPath + '/program' ">返回</router-link> -->
        <a class="xc-btn xc-btn-default" @click="close">返回</a>
        <a class="xc-btn xc-btn-primary" v-if="index != 0" @click="prev"
          >上一步</a
        >
        <a
          class="xc-btn xc-btn-primary"
          v-if="deviceResolution.length - 1 > index"
          @click="next"
          >下一步</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import programApi from "@/api/program";
import { setTimeout } from "timers";

export default {
  name: "programEditor",
  data() {
    return {
      // 节目详情
      programInfo: {},

      // 节目JSON
      programJson: [],
      resolution: null,
      deviceResolution: [],
      index: this.$route.query.index || 0,
      pIndex: 0,

      // 当前预览的节目
      currentProgram: null,
    };
  },
  created() {
    programApi
      .programDetail({
        programVersion: this.$route.params.programVersion,
      })
      .then((v) => {
        if (typeof v.data.sourceJson == "string") {
          v.data.sourceJson = JSON.parse(v.data.sourceJson);
        }
        this.deviceResolution = v.data.deviceResolution.split(",");
        this.programInfo = v.data;
        this.initData();
      });
  },
  methods: {
    // 初始化数据
    initData() {
      this.resolution = this.deviceResolution[this.index];
      this.programJson = this.programInfo.sourceJson[this.resolution];
      this.playProgram();
    },
    prev() {
      this.index = this.index - 1;
      this.$router.push(
        this.$config.adminPath +
          `/program/${this.programInfo.programVersion}/preview?index=${this.index}`
      );

      this.initData();
    },
    next() {
      this.index = this.index + 1;
      this.$router.push(
        this.$config.adminPath +
          `/program/${this.programInfo.programVersion}/preview?index=${this.index}`
      );

      this.initData();
    },
    // 播放节目
    playProgram(playIndex = 0) {
      const currentProgram = this.programJson[playIndex];

      if (currentProgram) {
        currentProgram.playIndex = playIndex;

        this.currentProgram = currentProgram;
        this.$forceUpdate();

        this.$nextTick(() => {
          if (playIndex + 1 >= this.programJson.length) {
            playIndex = 0;
          } else {
            playIndex = playIndex + 1;
          }

          setTimeout(() => {
            this.playProgram(playIndex);
          }, this.currentProgram.duration);
        });
      }
    },

    close: function () {
      if (parent.myLayer) {
        parent.myLayer.close(this.pIndex);
      }
    },
  },
  mounted() {
    if (parent.myLayer) {
      this.pIndex = parent.myLayer.getFrameIndex(window.name);
    }
  },
  computed: {
    // 屏幕类型 0、横屏 1、竖屏
    deviceType() {
      if (this.resolution) {
        const array = this.resolution.split("x");

        if (Number(array[0]) >= Number(array[1])) {
          return 0;
        } else {
          return 1;
        }
      } else {
        return -1;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/program-json.scss";
</style>
